import React from 'react';

export default ({ ...rest }) => (
  <svg width="20" height="20" viewBox="0 0 20 20" {...rest}>
    <g fillRule="evenodd" transform="rotate(90 10 10)">
      <path d="M10 7.982L5.438 3.419a1.424 1.424 0 0 0-2.019 0 1.424 1.424 0 0 0 0 2.019L7.982 10l-4.563 4.562a1.424 1.424 0 0 0 0 2.019c.269.269.635.42 1.006.42.378 0 .746-.15 1.015-.429l4.554-4.554 4.563 4.563c.268.269.634.42 1.006.42.382 0 .745-.149 1.015-.429.55-.55.55-1.45-.009-2.01l-4.551-4.561 4.563-4.563a1.424 1.424 0 0 0 0-2.019 1.424 1.424 0 0 0-2.019 0L10 7.982z" />
    </g>
  </svg>
);
